module.exports = __webpack_public_path__ + "media/whats_your_status_series/step-01-e07c2bbd.jpg";